import React, { useState } from 'react';
import { Typography } from "mobily-ui-library/lib";
import { ConfigProvider, Table } from "antd";
import { useTranslation } from "react-i18next";
import type { ColumnsType, TableProps } from "antd/es/table";
import type { FilterValue } from 'antd/es/table/interface';
import "./SearchResultTable.scss";

type SearchResultProps = {
  rtl: boolean;
  dir: string;
  tableData: any;
};

interface DataType {
  key: React.Key;
  date: string;
  period: string;
  dividends: string;
  bankName: string;
}

const win: any = window;

function SearchResultTable({ rtl, dir, tableData }: SearchResultProps) {
  const direction: any = dir;
  const { t } = useTranslation();
  const [filteredInfo, setFilteredInfo] = useState<Record<string, FilterValue | null>>({});
  const handleChange: TableProps<DataType>['onChange'] = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
  };
  const epochTime = (date:any) => {
    const arr = date.split('-')
    let myDate = new Date(Number(arr[2]), (Number(arr[1])-1), Number(arr[0]))
    return myDate.getTime()
  }
  
  const columns: ColumnsType<DataType> = [
    {
      title: t("Date"),
      dataIndex: "date",
      key: "date",
      width: "200px",
      sorter: (a:any, b:any) => epochTime(a.date) - epochTime(b.date)
    },
    {
      title: t("Period"),
      dataIndex: "period",
      key: "period",
      width: "200px",
      render: (text: any, record: any) => {
        if (record.bank === "" && record.dividends === "") {
          return <span className="year-column">{text}</span>;
        } else {
          return <span className="normal-column">{text}</span>;
        }
      },
    },
    {
      title: t("Dividends"),
      dataIndex: "dividends",
      key: "dividends",
    },
    {
      title: t("Bank"),
      dataIndex: "bankName",
      key: "bankName",
      width: "200px",
      filters: (() => {
        let uniqueFilters:any = []
        tableData.map((item:any)=>{
          const filter = win["lang"] === "en" ? item.bankNameEN : item.bankNameAR
          return { text: filter, value: filter}
        })
        .filter((item:any)=>{
          if(!uniqueFilters.some((filter:any) => JSON.stringify(filter) === JSON.stringify(item))){
            uniqueFilters.push(item)
          }
        })
        return uniqueFilters
      })(),
      filteredValue: filteredInfo.bankName || null,
      onFilter: (value: any, record) => record.bankName.includes(value),
    },
  ];

  const data = tableData.map((item: any, i: any) => {
    return {
      key: i + 1,
      date: item.dividendDate,
      period: item.period,
      dividends: win["lang"] === "en" ? item.messageEN : item.messageAR,
      bankName: win["lang"] === "en" ? item.bankNameEN : item.bankNameAR,
    };
  });

  return (
    <section className="searchResult_Table">
      <Typography className="search-heading" rtl={rtl}>
        {t("Search_results")}
      </Typography>
      <ConfigProvider direction={direction}>
        <Table
          className="search-table"
          pagination={false}
          dataSource={data}
          columns={columns}
          onChange={handleChange}
        />
      </ConfigProvider>
    </section>
  );
}

export default SearchResultTable;
